


const background = 'black';
// const cardBackground = '#1c1c1c'
const cardBackground = 'rgb(43, 43, 43)'
const darkerGray = '#1c1c1c'

export { background, cardBackground, darkerGray }